module.exports = "/images/Nuvem-shop_v2.png?e85ebb3196cd534d235b7d9fde60aec2";